import * as React from 'react'
import {noOperation} from 'definitions/constant'

export type FallbackType = NonNullable<React.ReactNode> | null

export interface FallbackContextType {
  updateFallback: (fallback: FallbackType) => void
}

export const FallbackContext = React.createContext<FallbackContextType>({
  updateFallback: noOperation,
})

interface FallbackProviderProps {
  children: React.ReactElement
}

export const FallbackProvider: React.FC<FallbackProviderProps> = ({
  children,
}) => {
  const [fallback, setFallback] = React.useState<FallbackType>(null)
  const updateFallback = React.useCallback(() => {
    // aFallback: FallbackType paramter
    // Setting this to null, as passing aFallback shows last loaded screen before transitioning to new screen.
    setFallback(null)
  }, [])

  const renderChildren = React.useMemo(() => {
    return children
  }, [children])

  return (
    <FallbackContext.Provider value={{updateFallback}}>
      <React.Suspense fallback={fallback}>{renderChildren}</React.Suspense>
    </FallbackContext.Provider>
  )
}
